module.exports = __webpack_public_path__ + "static/img/10commitments_7.05faed2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/10commitments_7.jpg
// module id = bTNq
// module chunks = 0